{
 "about": "pipeline/surfacegen.py PALETTE + MEASURED_KEYS for the device painter (groundref.js / groundgen.js); generated by scripts/check-gpupainter.mjs --write-pal, pinned by its pal row",
 "palette": {
  "meadow": {
   "base": [
    108,
    166,
    70
   ],
   "patch": [
    140,
    178,
    66
   ],
   "mid": 10,
   "dry": [
    168,
    162,
    92
   ],
   "lush": [
    80,
    138,
    60
   ]
  },
  "turf": {
   "base": [
    148,
    156,
    84
   ],
   "patch": [
    170,
    158,
    92
   ],
   "mid": 9,
   "dry": [
    178,
    158,
    102
   ],
   "lush": [
    110,
    140,
    72
   ]
  },
  "heath": {
   "base": [
    88,
    118,
    64
   ],
   "patch": [
    64,
    92,
    52
   ],
   "mid": 8,
   "dry": [
    122,
    112,
    72
   ],
   "lush": [
    62,
    104,
    58
   ]
  },
  "forest": {
   "base": [
    62,
    86,
    52
   ],
   "patch": [
    88,
    76,
    50
   ],
   "mid": 7
  },
  "scree": {
   "base": [
    158,
    154,
    148
   ],
   "patch": [
    172,
    162,
    146
   ],
   "mid": 6
  },
  "rock": {
   "base": [
    130,
    126,
    120
   ],
   "patch": [
    146,
    136,
    122
   ],
   "mid": 8
  },
  "gravel": {
   "base": [
    188,
    178,
    158
   ],
   "patch": [
    172,
    162,
    142
   ],
   "mid": 6
  },
  "wetland": {
   "base": [
    76,
    126,
    104
   ],
   "patch": [
    58,
    100,
    86
   ],
   "mid": 7,
   "dry": [
    112,
    122,
    82
   ],
   "lush": [
    52,
    98,
    78
   ]
  },
  "sport": {
   "base": [
    82,
    170,
    90
   ],
   "patch": [
    96,
    182,
    98
   ],
   "mid": 4
  },
  "lawn": {
   "base": [
    122,
    182,
    96
   ],
   "patch": [
    108,
    170,
    88
   ],
   "mid": 6,
   "dry": [
    152,
    170,
    92
   ],
   "lush": [
    96,
    162,
    80
   ]
  },
  "piste": {
   "base": [
    158,
    198,
    118
   ],
   "patch": [
    140,
    186,
    108
   ],
   "mid": 5,
   "dry": [
    172,
    172,
    102
   ],
   "lush": [
    112,
    162,
    82
   ]
  },
  "dirt": {
   "base": [
    146,
    116,
    84
   ],
   "patch": [
    122,
    96,
    70
   ],
   "mid": 8
  },
  "asphalt": {
   "base": [
    95,
    95,
    102
   ],
   "patch": [
    104,
    104,
    110
   ],
   "mid": 3
  },
  "paved": {
   "base": [
    152,
    146,
    152
   ],
   "patch": [
    140,
    134,
    142
   ],
   "mid": 4
  },
  "ballast": {
   "base": [
    106,
    100,
    94
   ],
   "patch": [
    118,
    110,
    102
   ],
   "mid": 6
  },
  "snow": {
   "base": [
    240,
    244,
    250
   ],
   "patch": [
    224,
    232,
    246
   ],
   "mid": 3
  },
  "water": {
   "deep": [
    20,
    62,
    86
   ]
  }
 },
 "measured_keys": [
  "meadow",
  "turf",
  "lawn",
  "piste",
  "sport",
  "wetland",
  "heath"
 ]
}
